import { PaymentMethodEnum } from '@/types/common';

export const AVILABLE_PAYMENT_METHOD_COUNT = 4;

export const REDIRECT_PAYMENT_POLLING_INTERVAL = 1000;

export const MAXIMUM_CREDIT_CARD_ALLOWED = 5;

export const AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER = 3;

export const MAX_LENGTH_CVC = 4;

export const TEXT_BY_PAYMENT_METHOD: Record<PaymentMethodEnum, string> = {
  [PaymentMethodEnum.CREDIT_CARD]: 'Pay with debit or credit card',
  [PaymentMethodEnum.PAYPAL]: 'PayPal',
  [PaymentMethodEnum.GOOGLE_PAY]: 'Google Pay',
  [PaymentMethodEnum.OTHER]: '',
  [PaymentMethodEnum.APPLE_PAY]: 'Apple Pay',
  [PaymentMethodEnum.CASH_APP]: 'Cash App',
  [PaymentMethodEnum.KLARNA]: 'Klarna',
  [PaymentMethodEnum.LINK]: 'Link',
  [PaymentMethodEnum.UNIONPAY]: 'UnionPay',
  [PaymentMethodEnum.VERIFON]: 'Verifone',
  [PaymentMethodEnum.AMAZON_PAY]: 'Amazon Pay',
  [PaymentMethodEnum.PIX]: 'Pix Payment',
  [PaymentMethodEnum.VENMO]: 'Venmo',
  [PaymentMethodEnum.AFTERPAY]: 'Afterpay',
  [PaymentMethodEnum.IDEAL]: 'Ideal',
  [PaymentMethodEnum.AFFIRM]: 'Affirm',
  [PaymentMethodEnum.NEOSURF]: 'Neosurf',
  [PaymentMethodEnum.NUVEI_NEOSURF]: 'Neosurf',
  [PaymentMethodEnum.BLIK]: 'Blik',
  [PaymentMethodEnum.BLIK_CHECKOUT]: 'Blik',
  [PaymentMethodEnum.P24]: 'Przelewy 24',
  [PaymentMethodEnum.TRUSTLY]: 'Trustly',
  [PaymentMethodEnum.EPS]: 'EPS',
  [PaymentMethodEnum.BANCONTACT]: 'Bancontact',
  [PaymentMethodEnum.ALIPAY]: 'Alipay',
  [PaymentMethodEnum.PAYME]: 'Payme',
  [PaymentMethodEnum.SCALA_PAY]: 'Scalapay',
};
